module.exports = __webpack_public_path__ + "img/apple.b8ee104e.png";